import { render, staticRenderFns } from "./InvisibleController.vue?vue&type=template&id=b12050c2&scoped=true&"
import script from "./InvisibleController.vue?vue&type=script&lang=ts&"
export * from "./InvisibleController.vue?vue&type=script&lang=ts&"
import style0 from "./InvisibleController.vue?vue&type=style&index=0&id=b12050c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12050c2",
  null
  
)

export default component.exports